/**
 * 员工 表单验证规则
 * @author zjs
 * @time 2017-12-11
 */
export default {
    data () {
        // 非空的判断
        var isNoEmpty = (rule, value, callback) => {
            if (value === '' || value === undefined) {
                callback(new Error('请输入'))
            } else {
                callback()
            }
        }
        var isPhone = (rule, value, callback) => {
            if (value === '' || value === undefined || !value.match(/^(1\d{10})$/)) {
                callback(new Error('请输入'))
            } else {
                callback()
            }
        }
        return {
            formRules: {
                'phone': [{ validator: isPhone, required: true, trigger: 'blur' }],
                'name': [{ required: true, trigger: 'blur' }],
                'role_display_id':  [{ validator: isNoEmpty, required: true, trigger: 'blur' }],
                'quanxian_id':  [{ validator: isNoEmpty, required: true, trigger: 'blur' }],
                'warehouse_ids': [{ type: 'array', required: true, message: '请选择仓库', trigger: 'change' }]
            }
        }
    }
}